<div class="row">
  <div class="col-12">
    <astrobin-equipment-item-browser
      #itemBrowser
      *ngIf="enableBrowser"
      [enableFullscreen]="true"
      [showItemTypeSelector]="false"
      [type]="activeType"
      [value]="this.activeId"
      (creationModeEnded)="onCreationModeEnded()"
      (creationModeStarted)="onCreationModeStarted()"
      (itemTypeChanged)="onItemTypeChanged($event)"
      (valueChanged)="onSelectedItemChanged($event)"
    ></astrobin-equipment-item-browser>
  </div>
</div>
<!-- browser row -->

<div class="row g-0 g-3">
  <div [class.col-lg-9]="showListings()" class="col-12 order-last order-lg-first">
    <div *ngIf="!!selectedItem" [class.disabled-with-backdrop]="subCreationMode" class="card">
      <div class="backdrop"></div>

      <div class="card-header">
        {{ equipmentItemService.humanizeType(activeType) }}

        <div class="actions">
          <button
            [class.loading]="loadingService.loading$ | async"
            [disabled]="editMode"
            (click)="resetBrowser()"
            class="btn btn-link link-secondary"
          >
            &times;
          </button>
        </div>
      </div>

      <div class="card-body">
        <div *ngIf="selectedItem.reviewerDecision === null && !!selectedItem.brand" class="alert alert-warning">
          {{
            "This item has not been approved yet, so it's not available to be associated with images, except for the user who created it."
              | translate
          }}
        </div>

        <div *ngIf="!!selectedItem.frozenAsAmbiguous" class="alert alert-warning">
          {{ "This item is frozen as ambiguous and cannot be associated to images again." | translate }}
        </div>

        <astrobin-equipment-item-summary
          [enableBrandLink]="true"
          [item]="selectedItem"
          [showClass]="false"
          [showCommunityNotes]="true"
          [showEmptyProperties]="true"
          [showLargeImage]="true"
          [showMeta]="true"
          [showMostOftenUsedWith]="true"
          (editButtonClick)="startEditMode()"
        ></astrobin-equipment-item-summary>

        <div *ngIf="!!selectedItem.variantOf || selectedItem.variants?.length > 0" class="item-variants-container">
          <ng-container *ngIf="selectedItem.variants?.length > 0; else variantTemplate">
            {{ "Also available in the following variants:" | translate }}

            <span class="item-variants">
              <a
                *ngFor="let variant of selectedItem.variants"
                [routerLink]="['/equipment/explorer/', variant.klass.toLowerCase(), variant.id]"
                class="item-variant"
              >
                <ng-container
                  *ngIf="
                    selectedItem.klass === EquipmentItemType.CAMERA &&
                      asCamera(selectedItem).type === CameraType.DSLR_MIRRORLESS;
                    else notDslrOrMirrorlessCamera
                  "
                >
                  <span *ngIf="!asCamera(variant).modified && !asCamera(variant).cooled">
                    <fa-icon icon="camera"></fa-icon>
                    {{ "Regular" | translate }}
                  </span>

                  <span
                    *ngIf="asCamera(variant).modified && !asCamera(variant).cooled"
                    [ngbPopover]="modificationPopoverMessage()"
                    [popoverTitle]="modificationTitle()"
                    triggers="mouseenter:mouseleave"
                  >
                    <fa-icon icon="microchip"></fa-icon>
                    {{ modificationTitle() }}
                  </span>

                  <span
                    *ngIf="!asCamera(variant).modified && asCamera(variant).cooled"
                    [ngbPopover]="coolingPopoverMessage()"
                    [popoverTitle]="coolingTitle()"
                    triggers="mouseenter:mouseleave"
                  >
                    <fa-icon icon="icicles"></fa-icon>
                    {{ coolingTitle() }}
                  </span>

                  <span
                    *ngIf="asCamera(variant).modified && asCamera(variant).cooled"
                    [ngbPopover]="modificationPopoverMessage() + ' ' + coolingPopoverMessage()"
                    [popoverTitle]="modificationTitle() + ' + ' + coolingTitle()"
                    triggers="mouseenter:mouseleave"
                  >
                    <fa-icon icon="microchip"></fa-icon>
                    {{ modificationTitle() }}
                    <fa-icon icon="plus"></fa-icon>
                    <fa-icon icon="icicles"></fa-icon>
                    {{ coolingTitle() }}
                  </span>
                </ng-container>

                <ng-template #notDslrOrMirrorlessCamera>
                  <astrobin-equipment-item-display-name
                    [cut]="selectedItem.name"
                    [item]="variant"
                    [showBrand]="false"
                  ></astrobin-equipment-item-display-name>
                </ng-template>
              </a>
            </span>
          </ng-container>

          <ng-template #variantTemplate>
            <ng-container *ngIf="!!selectedItem.variantOf">
              <ng-container
                *ngIf="
                  selectedItem.klass === EquipmentItemType.CAMERA &&
                    asCamera(selectedItem).type === CameraType.DSLR_MIRRORLESS;
                  else variantNotDslrOrMirrorlessCamera
                "
              >
                {{ "This is a modified and/or custom-cooled variant of this camera." | translate }}
                <a [routerLink]="['/equipment/explorer/', selectedItem.klass.toLowerCase(), selectedItem.variantOf]">
                  {{ "Go to regular variant." | translate }}
                </a>
              </ng-container>
              <ng-template #variantNotDslrOrMirrorlessCamera>
                {{ "This is a variant of another equipment item." | translate }}
                <a [routerLink]="['/equipment/explorer/', selectedItem.klass.toLowerCase(), selectedItem.variantOf]">
                  {{ "Go to base variant." | translate }}
                </a>
              </ng-template>
            </ng-container>
          </ng-template>
        </div>
      </div>

      <div class="card-footer">
        <ng-container *ngIf="currentUserWrapper$ | async as currentUserWrapper">
          <ng-container *ngIf="!!currentUserWrapper.user">
            <button
              *ngIf="!selectedItem.frozenAsAmbiguous || (currentUserWrapper.user | isEquipmentModerator)"
              [class.loading]="loadingService.loading$ | async"
              [disabled]="editMode"
              (click)="startEditMode()"
              class="btn btn-secondary"
              data-test="propose-edit"
            >
              <fa-icon icon="pencil"></fa-icon>
              {{ "Propose edit" | translate }}&hellip;
            </button>

            <button (click)="onFollowClick()" class="btn btn-secondary" type="button">
              <fa-icon icon="bell"></fa-icon>
              <span *ngIf="isFollowingAnything()">{{ "Unfollow" | translate }}</span>
              <span *ngIf="!isFollowingAnything()">{{ "Follow" | translate }}</span>
            </button>

            <button
              *ngIf="selectedItem.klass !== 'SENSOR'"
              (click)="sellInMarketplace()"
              class="btn btn-secondary"
              data-test="sell-in-marketplace"
            >
              <fa-icon icon="shopping-cart"></fa-icon>
              {{ "Sell" | translate }}
            </button>

            <div *ngIf="currentUserWrapper.user | isEquipmentModerator" ngbDropdown>
              <button
                [class.loading]="loadingService.loading$ | async"
                [disabled]="(readOnlyMode$ | async) === true"
                id="moderate-menu"
                class="btn btn-danger"
                ngbDropdownToggle
                type="button"
              >
                <fa-icon icon="gavel"></fa-icon>
                {{ "Moderate" | translate }}
              </button>

              <div [attr.aria-labelledby]="'moderate-menu'" ngbDropdownMenu>
                <button
                  *ngIf="typeSupportsMigrateInto()"
                  [disabled]="editMode"
                  (click)="startMigrationMode()"
                  data-test="migrate-into"
                  ngbDropdownItem
                >
                  <fa-icon icon="dot-circle"></fa-icon>
                  {{ "Migrate into" | translate }}&hellip;
                </button>

                <ng-container
                  *ngIf="
                    !!selectedItem.brand &&
                    selectedItem.reviewerDecision === EquipmentItemReviewerDecision.APPROVED &&
                    !selectedItem.frozenAsAmbiguous
                  "
                >
                  <button
                    [class.loading]="loadingService.loading$ | async"
                    [disabled]="editMode"
                    (click)="startFreezeAsAmbiguous()"
                    class="text-warning"
                    data-test="freeze-as-ambiguous"
                    ngbDropdownItem
                  >
                    <fa-icon icon="snowflake"></fa-icon>
                    {{ "Freeze" | translate }}&hellip;
                  </button>
                </ng-container>

                <ng-container
                  *ngIf="
                    !!selectedItem.brand &&
                    selectedItem.reviewerDecision === EquipmentItemReviewerDecision.APPROVED &&
                    selectedItem.frozenAsAmbiguous
                  "
                >
                  <button
                    [class.loading]="loadingService.loading$ | async"
                    [disabled]="editMode"
                    (click)="startUnfreezeAsAmbiguous()"
                    class="text-warning"
                    data-test="freeze-as-ambiguous"
                    ngbDropdownItem
                  >
                    <fa-icon icon="temperature-high"></fa-icon>
                    {{ "Unfreeze" | translate }}&hellip;
                  </button>
                </ng-container>

                <ng-container *ngIf="!selectedItem.assignee || selectedItem.assignee === currentUserWrapper.user?.id">
                  <ng-container
                    *ngIf="
                      selectedItem.reviewerDecision === null && selectedItem.createdBy !== currentUserWrapper.user?.id
                    "
                  >
                    <button
                      [class.loading]="loadingService.loading$ | async"
                      [disabled]="editMode"
                      (click)="startRejection()"
                      class="text-danger"
                      data-test="reject"
                      ngbDropdownItem
                    >
                      <fa-icon icon="ban"></fa-icon>
                      {{ "Reject" | translate }}&hellip;
                    </button>

                    <button
                      [class.loading]="loadingService.loading$ | async"
                      [disabled]="editMode"
                      (click)="startApproval()"
                      class="text-success"
                      data-test="reject"
                      ngbDropdownItem
                    >
                      <fa-icon icon="check"></fa-icon>
                      {{ "Approve" | translate }}&hellip;
                    </button>
                  </ng-container>

                  <ng-container
                    *ngIf="
                      selectedItem.reviewerDecision === EquipmentItemReviewerDecision.APPROVED &&
                      selectedItem.createdBy !== currentUserWrapper.user?.id
                    "
                  >
                    <button
                      [class.loading]="loadingService.loading$ | async"
                      [disabled]="editMode"
                      (click)="startUnapproval()"
                      class="text-danger"
                      data-test="unapprove"
                      ngbDropdownItem
                    >
                      <fa-icon icon="rotate-left"></fa-icon>
                      {{ "Unapprove" | translate }}&hellip;
                    </button>
                  </ng-container>
                </ng-container>
              </div>
            </div>

            <a
              [class.loading]="loadingService.loading$ | async"
              (click)="compareService.addWithErrorHandling(selectedItem)"
              class="add-to-compare"
              astrobinEventPreventDefault
              href="#"
            >
              <fa-icon [ngbTooltip]="'Add to comparison list' | translate" icon="list-alt"></fa-icon>
            </a>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <ng-container *ngIf="selectedItem">
      <ng-container *ngIf="editProposals !== null; else loadingEditProposals">
        <div *ngIf="editProposals.length > 0" class="edit-proposals">
          <ng-container *ngIf="showEditProposals(); else editProposalsCollapsedTemplate">
            <div (click)="collapseEditProposals()" class="edit-proposals-header">
              <div class="row">
                <span class="col">{{ "Edit proposal by" | translate }}</span>
                <span class="col-2 d-none d-lg-inline">{{ "Changes" | translate }}</span>
                <span class="col-4 col-lg-3">{{ "Status" | translate }}</span>
                <span class="col-3 d-none d-lg-inline">{{ "Time" | translate }}</span>
              </div>
            </div>

            <astrobin-item-edit-proposal
              *ngFor="let editProposal of editProposals"
              [editProposal]="editProposal"
              [opened]="activeEditProposalId === editProposal.id"
            ></astrobin-item-edit-proposal>
          </ng-container>

          <ng-template #editProposalsCollapsedTemplate>
            <div
              [innerHTML]="collapsedEditProposalsMessage(editProposals)"
              (click)="expandEditProposals()"
              class="edit-proposals-collapsed"
            ></div>
          </ng-template>
        </div>
      </ng-container>

      <ng-template #loadingEditProposals>
        <div class="loading-edit-proposals">
          {{ "Loading edit proposals" | translate }}
          <astrobin-text-loading-indicator></astrobin-text-loading-indicator>
        </div>
      </ng-template>
    </ng-container>

    <ng-container *ngIf="editMode">
      <div class="mt-4 mb-4 text-center">
        <fa-icon icon="arrow-down"></fa-icon>
      </div>

      <div [class.disabled-with-backdrop]="subCreationMode" id="edit-item" class="card mt-4 mb-4">
        <div class="backdrop"></div>

        <div class="card-info alert alert-info">
          <fa-icon icon="info-circle"></fa-icon>
          {{ "The AstroBin equipment database is a collective community effort similar to Wikipedia." | translate }}
          {{ "Any changes you make will be reviewed by other members." | translate }}
          {{ "Feel free to contribute!" | translate }}
        </div>

        <div class="card-header">
          {{ "Propose edit" | translate }}
        </div>

        <div class="card-body">
          <astrobin-read-only-mode
            *ngIf="(readOnlyMode$ | async) === true; else formTemplate"
          ></astrobin-read-only-mode>

          <ng-template #formTemplate>
            <astrobin-camera-editor
              #editor
              *ngIf="activeType === EquipmentItemType.CAMERA"
              [editorMode]="EquipmentItemEditorMode.EDIT_PROPOSAL"
              [form]="editForm"
              [model]="editModel"
              (subCreationInProgress)="subCreationMode = $event"
            ></astrobin-camera-editor>

            <astrobin-sensor-editor
              #editor
              *ngIf="activeType === EquipmentItemType.SENSOR"
              [editorMode]="EquipmentItemEditorMode.EDIT_PROPOSAL"
              [form]="editForm"
              [model]="editModel"
              (subCreationInProgress)="subCreationMode = $event"
            ></astrobin-sensor-editor>

            <astrobin-telescope-editor
              #editor
              *ngIf="activeType === EquipmentItemType.TELESCOPE"
              [editorMode]="EquipmentItemEditorMode.EDIT_PROPOSAL"
              [form]="editForm"
              [model]="editModel"
              (subCreationInProgress)="subCreationMode = $event"
            ></astrobin-telescope-editor>

            <astrobin-mount-editor
              #editor
              *ngIf="activeType === EquipmentItemType.MOUNT"
              [editorMode]="EquipmentItemEditorMode.EDIT_PROPOSAL"
              [form]="editForm"
              [model]="editModel"
              (subCreationInProgress)="subCreationMode = $event"
            ></astrobin-mount-editor>

            <astrobin-filter-editor
              #editor
              *ngIf="activeType === EquipmentItemType.FILTER"
              [editorMode]="EquipmentItemEditorMode.EDIT_PROPOSAL"
              [form]="editForm"
              [model]="editModel"
              (subCreationInProgress)="subCreationMode = $event"
            ></astrobin-filter-editor>

            <astrobin-accessory-editor
              #editor
              *ngIf="activeType === EquipmentItemType.ACCESSORY"
              [editorMode]="EquipmentItemEditorMode.EDIT_PROPOSAL"
              [form]="editForm"
              [model]="editModel"
              (subCreationInProgress)="subCreationMode = $event"
            ></astrobin-accessory-editor>

            <astrobin-software-editor
              #editor
              *ngIf="activeType === EquipmentItemType.SOFTWARE"
              [editorMode]="EquipmentItemEditorMode.EDIT_PROPOSAL"
              [form]="editForm"
              [model]="editModel"
              (subCreationInProgress)="subCreationMode = $event"
            ></astrobin-software-editor>
          </ng-template>
        </div>

        <div class="card-footer">
          <button
            [class.loading]="loadingService.loading$ | async"
            (click)="cancelEditMode()"
            class="btn btn-sm-block btn-secondary"
          >
            {{ "Cancel" | translate }}
          </button>

          <button
            [class.loading]="(loadingService.loading$ | async) || editForm.pending"
            [disabled]="(readOnlyMode$ | async) === true"
            (click)="proposeEdit()"
            class="btn btn-sm-block btn-primary"
            data-test="propose-edit-confirm"
          >
            {{ "Propose edit" | translate }}
          </button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="currentUser$ | async as currentUser">
      <ng-container
        *ngIf="selectedItem && (currentUser.id === selectedItem.createdBy || (currentUser | isEquipmentModerator))"
      >
        <div *ngIf="contentType$ | async as contentType" class="comments mt-3">
          <astrobin-nested-comments
            [contentType]="contentType"
            [info]="commentsSectionInfoMessage$ | async"
            [objectId]="selectedItem.id"
          ></astrobin-nested-comments>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="!!selectedItem && isBrowser">
      <ng-container *ngIf="marketplaceListings$ | async as listings">
        <div *ngIf="listings?.length > 0" class="card mt-5">
          <div class="card-header">
            {{ "Marketplace listings" | translate }}
          </div>

          <div class="card-body">
            <astrobin-marketplace-listing-cards [listings]="listings"></astrobin-marketplace-listing-cards>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="!!selectedItem && isBrowser">
      <astrobin-forum-preview
        *ngIf="showForum && !!selectedItem.forum"
        [forumId]="selectedItem.forum"
        class="mt-5 d-block"
      >
      </astrobin-forum-preview>

      <astrobin-image-search-card
        [header]="'Acquired with this item' | translate"
        [model]="searchModel"
        [showMarketplaceItems]="false"
        [showRetailers]="false"
        [showStaticOverlay]="false"
        class="mt-5 d-block"
        ordering="-likes"
      ></astrobin-image-search-card>
    </ng-container>
  </div>
  <!-- main pane -->

  <div *ngIf="showListings()" class="col-12 col-lg-3 sidebar">
    <astrobin-equipment-listings
      [item]="selectedItem"
      [listings]="selectedItem.listings"
      class="d-block mb-0 mb-lg-5"
    ></astrobin-equipment-listings>
  </div>
  <!-- side pane -->
</div>
<!-- card row -->

<!-- Equipment follow options component -->
<astrobin-equipment-follow-options></astrobin-equipment-follow-options>
